import App from "./App.vue";
import { createVueFrontApp } from "@vuefront-create-app";

export const createApp = async (runtimeContext = {}) => {
  const m = await createVueFrontApp(App, runtimeContext);
  return m;
};
